import React from "react";
import worship from "../assets/worship.jpg";

const About = () => {
  return (
    <section id="about" className="w-full bg-cream py-20 px-4 md:py-28">
      <div className="mx-auto grid max-w-[1240px] items-center gap-12 md:grid-cols-2">
        {/* Image */}
        <div className="relative">
          <img
            className="aspect-[4/3] w-full rounded-2xl object-cover shadow-xl"
            src={worship}
            alt="The Little Flock congregation gathered in worship"
            loading="lazy"
          />
          <div className="absolute -bottom-5 -right-3 hidden rounded-xl bg-maroon px-6 py-4 text-white shadow-lg sm:block">
            <p className="font-serif text-2xl font-bold leading-none">Est.</p>
            <p className="text-sm text-peach">in faith &amp; family</p>
          </div>
        </div>

        {/* Text */}
        <div>
          <p className="section-label">Welcome</p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-maroon sm:text-4xl">
            Who We Are
          </h2>

          <blockquote className="mt-6 border-l-4 border-terracotta pl-4 text-lg italic text-ink/80">
            “For where two or three are gathered together in My name, I am there
            in the midst of them.”
            <span className="mt-1 block text-sm font-semibold not-italic text-terracotta">
              Matthew 18:20
            </span>
          </blockquote>

          <div className="mt-6 space-y-4 text-ink/80">
            <p>
              We are a small congregation of the Bride of Jesus Christ serving
              the Kitchener, Waterloo and Cambridge area in the Province of
              Ontario, Canada.
            </p>
            <p>
              We are of Apostolic Faith, believers of the End-Time Message
              according to Malachi 4:5–6, Luke 17:30 and Revelation 10:7. We
              would be very happy to have you and your loved ones worship with
              us. May God richly bless you.
            </p>
          </div>

          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#visit" className="btn-outline">
              Plan Your Visit
            </a>
            <a href="#gallery" className="btn-outline border-terracotta text-terracotta hover:bg-terracotta">
              See Our Church
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
